import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js'
import { generateNamespacesNavigator } from 'trunks/vue/admin/components/namespaces/namespaces_navigator.js'
import NamespacesTable from 'trunks/vue/admin/components/namespaces/namespaces_table.js'
import NamespaceDetail from 'trunks/vue/admin/components/namespaces/namespace_detail.js'
import NamespaceForm from 'trunks/vue/admin/components/namespaces/namespace_form.js'

class Admin__NamespacesController extends Skylark.App.BaseController {
  index() {
    this._generateNamespacesSidebarView(null)

    Skylark.Libs.Ajax.get('/admin/namespaces.json', {
      responseType: 'json',
      success: (namespaces) => {
        new NamespacesTable({
          el: DomMaster.find('#js_namespaces_container').node,
          propsData: {
            initialNamespaces: namespaces
          }
        })
      }
    })
  }

  show() {
    const container = DomMaster.find('#js_namespaces_container').node
    const namespaceId = String(container.dataset.namespaceId)

    this._generateNamespacesSidebarView(namespaceId)

    Skylark.Libs.Ajax.get(`/admin/namespaces/${namespaceId}.json`, {
      responseType: 'json',
      success: (namespace) => {
        new NamespaceDetail({
          el: container,
          propsData: {
            initialNamespace: namespace,
            features: this.getVars('features') || []
          }
        })
      }
    })
  }

  new() {
    this._generateNamespacesSidebarView('new')

    new NamespaceForm({
      el: DomMaster.find('#js_namespaces_container').node,
      propsData: {
        mode: 'new',
        initialNamespace: null,
        features: this.getVars('features') || []
      }
    })
  }

  edit() {
    const container = DomMaster.find('#js_namespaces_container').node
    const namespaceId = String(container.dataset.namespaceId)

    this._generateNamespacesSidebarView(namespaceId)

    Skylark.Libs.Ajax.get(`/admin/namespaces/${namespaceId}.json`, {
      responseType: 'json',
      success: (namespace) => {
        new NamespaceForm({
          el: container,
          propsData: {
            mode: 'edit',
            initialNamespace: namespace,
            features: this.getVars('features') || []
          }
        })
      }
    })
  }
}

Admin__NamespacesController.include(GenerateMorePopover, generateNamespacesNavigator)

export default Admin__NamespacesController
